export function isEdge() {
    const appVersion = window.navigator.appVersion;
    return appVersion.indexOf('Edge') !== -1;
}

export function isIE11() {
    const userAgent = navigator.userAgent;
    return !!(userAgent.match(/Trident/) && userAgent.match(/rv[ :]11/));
}

export function isFirefox() {
    const userAgent = navigator.userAgent;
    return userAgent.includes('Firefox');
}

export const isIe9 = () => {
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;

    if (isIE) {
        const ieVersion = parseInt(userAgent.split('MSIE ')[1], 10) || parseInt(userAgent.split('rv:')[1], 10);
        return ieVersion === 9;
    }
    return false;
};

export const isIe10 = () => {
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;

    if (isIE) {
        const ieVersion = parseInt(userAgent.split('MSIE ')[1], 10) || parseInt(userAgent.split('rv:')[1], 10);
        return ieVersion === 10;
    }
    return false;
};